import {useState} from 'react';

export const isOnline = () => navigator.onLine;
export const useOnlineStatus = () => {
    const [online, setOnline] = useState(isOnline());

    window.addEventListener('online', () => setOnline(isOnline()));
    window.addEventListener('offline', () => setOnline(isOnline()));

    return {online, offline: !online};
};


